import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  TextField,
  Typography,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Grid,
  IconButton,
  Tooltip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  FormControlLabel,
  Switch,
  Radio,
  RadioGroup,
  FormLabel,
  Checkbox,
  Modal, Alert, Popover, Autocomplete
} from "@mui/material";
import { axiosInstance, localAxiosDelete, localAxiosPut } from "../../../Axios/axios";
import axios from "axios";
import { Spinner } from "../spinner";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import back from '../../../assets/Back.png';
import { useSnackbar } from 'notistack';
import { employeeApi } from "../../../services/api";
import {
  BarChart,
  PieChart,
} from "@mui/x-charts";
import {
  Download,
  Person,
  Email,
  Cake,
  Work,
  Phone,
  CheckCircle,
  Cancel,
  Business,
  Grade,
  Badge, CloudDownload as CloudDownloadIcon,
  Close, FileDownloadOutlined as FileDownloadOutlinedIcon
} from "@mui/icons-material";
import { localAxios } from "../../../Axios/axios";
import { localAxiosGet } from "../../../Axios/axios";
import TokenExpirePopup from '../../../components/TokenExpirePopup';
import { useNavigate } from 'react-router-dom';
import { CloudUpload } from "lucide-react";
import AddEmployeeUsingCSV from "./AddEmployeeUsingCSV";
import EditEmployeeDetails from "./EditEmployeeDetails";
import VisibilityIcon from '@mui/icons-material/Visibility';
import ViewEmployeeDetails from "./viewEmployeeDetails/ViewEmployeeDetails";


export default function EmployeeManagement({ setSelectedMenu }) {
  const resetForm = () => {
    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      dateOfBirth: "",
      joiningDate: "",
      department: "",
      departmentName: "",
      team: "",
      teamName: "",
      designation: "",
      designationName: "",
      status: "inActive",
      employmentType: "Full-Time",
      grade: "",
      isManager: false,
      isTeamLead: false,
      location: "",
      reportingManager: "",
      roleId: '',
      roleName: '',
      employeeId: ''
    });
  };

  const [locations, setLocations] = useState([]);
  const [loadingLocations, setLoadingLocations] = useState(false);
  const [loadingTeams, setLoadingTeams] = useState(false);
  const [loadingDesignations, setLoadingDesignations] = useState(false);
  const [designations, setDesignations] = useState([]);
  const [teams, setTeams] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [userId, setUserId] = useState(null);
  const [organizationId, setOrganizationId] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [managerOptions, setmanagerOptions] = useState([]);
  const [managerInputValue, setManagerInputValue] = useState('');
  const [openTokenExpirePopup, setOpenTokenExpirePopup] = useState(false);
  const navigate = useNavigate();

  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [editEmployeeId, setEditEmployeeId] = useState(null);
  const [rolesNamesList, setRolesNamesList] = useState([])
  const [originalFormData, setOriginalFormData] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const token = localStorage.getItem('accessToken');

  const fetchAllEmployeesByOrgId = async (org_id) => {
    try {
      setLoading(true);
      const token = localStorage.getItem('accessToken');
      console.log('Fetching employees for organization ID:', org_id);

      if (!org_id) {
        console.error('Organization ID not found');
        return;
      }

      const response = await axiosInstance(localAxiosGet(`organization/getAllEmployeesByOrganizationId?organization_id=${org_id}`, token));

      if (response.data && response.data.status === "SUCCESS" && response.data.message && response.data.message.employees) {
        const employeesData = response.data.message.employees;
        console.log('Extracted employees data:', employeesData);
        setEmployees(employeesData);
      } else {
        console.error('Unexpected API response structure:', response.data);
        setEmployees([]);
      }
    } catch (error) {
      console.log('Error while fetching employees', error);
      if (error.response && error.response.status === 403) {
        setOpenTokenExpirePopup(true);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const storedUserId = localStorage.getItem("userId");
    const storedOrgId = localStorage.getItem("organizationId");
    const storedUserDetails = localStorage.getItem("userDetails");

    if (storedUserId) setUserId(storedUserId);
    if (storedOrgId) setOrganizationId(storedOrgId);
    if (storedUserDetails) {
      try {
        setUserDetails(JSON.parse(storedUserDetails));
      } catch (e) {
        console.error("Error parsing user details:", e);
      }
    }

    console.log("Dashboard loaded with User ID:", storedUserId);
    console.log("Dashboard loaded with Organization ID:", storedOrgId);
  }, []);

  const fetchDesignationsByTeamId = async (teamId) => {
    try {
      setLoadingDesignations(true);
      console.log('Fetching designations for team ID:', teamId);
      const token = localStorage.getItem('accessToken');
      const response = await axiosInstance(localAxiosGet(`/organization/getAllDesignationsByTeamId/${teamId}`, token));

      console.log('Designations Response:', response);

      if (response.data && response.data.message && response.data.message.designations) {
        const designationsData = response.data.message.designations || [];
        console.log('Extracted Designations Data:', designationsData);

        const designationsArray = designationsData.map(designation => ({
          id: designation.id,
          name: designation.designation
        }));

        console.log('Final Designations Array:', designationsArray);
        setDesignations(designationsArray);
      } else {
        console.error("Unexpected API response structure:", response.data);
        enqueueSnackbar('Unexpected API response format for designations', { variant: 'error' });
        setDesignations([]);
      }
    } catch (error) {
      console.error('Error fetching designations:', error);
      if (error.response) {
        console.error('Response data:', error.response.data);
        console.error('Response status:', error.response.status);
      } else if (error.request) {
        console.error('No response received:', error.request);
      } else {
        console.error('Error message:', error.message);
      }

      enqueueSnackbar('Failed to load designations', { variant: 'error' });
      setDesignations([]);
    } finally {
      setLoadingDesignations(false);
    }
  };

  const fetchDepartmentsByOrganizationId = async (orgId) => {
    try {
      setLoading(true);
      console.log("Fetching departments for organization ID:", orgId);
      const token = localStorage.getItem('accessToken');
      const response = await axiosInstance(localAxiosGet(`/organization/getAllDepartmentsByOrganizationId/${orgId}`, token));

      console.log("FULL RESPONSE OBJECT:", response);
      console.log("RESPONSE DATA:", response.data);

      if (response.data && response.data.message && response.data.message.departments) {
        const departmentsData = response.data.message.departments || [];
        console.log("EXTRACTED DEPARTMENTS DATA:", departmentsData);

        const departmentsArray = departmentsData.map(dept => ({
          id: dept.id,
          name: dept.department
        }));

        console.log("FINAL DEPARTMENTS ARRAY:", departmentsArray);
        console.log("ARRAY LENGTH:", departmentsArray.length);
        setDepartments(departmentsArray);
      } else {
        console.error("Unexpected API response structure:", response.data);
        enqueueSnackbar('Unexpected API response format', { variant: 'error' });
        setDepartments([]);
      }
    } catch (error) {
      console.error('Error fetching departments:', error);
      if (error.response) {
        console.error('Response data:', error.response.data);
        console.error('Response status:', error.response.status);
      } else if (error.request) {
        console.error('No response received:', error.request);
      } else {
        console.error('Error message:', error.message);
      }

      enqueueSnackbar('Failed to load departments', { variant: 'error' });
      setDepartments([]);

      if (error.response && error.response.status === 403) {
        setOpenTokenExpirePopup(true);
      }
    } finally {
      setLoading(false);
    }
  };
  const handleCancelButton = () => {
    setIsDialogOpen(false);
    resetForm();
  }


  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  useEffect(() => {
    if (organizationId) {
      console.log("About to fetch departments with organizationId:", organizationId);
      fetchDepartmentsByOrganizationId(organizationId);
      fetchAllEmployeesByOrgId(organizationId);
    } else {
      console.log("No organizationId available yet");
    }
  }, [organizationId]);

  const fetchTeamsByDepartmentId = async (departmentId) => {
    try {
      setLoadingTeams(true);
      console.log("Fetching teams for department ID:", departmentId);
      const token = localStorage.getItem('accessToken');
      const response = await axiosInstance(localAxiosGet(`/organization/getAllTeamsByDepartmentId/${departmentId}`, token));

      console.log("TEAMS RESPONSE:", response);

      if (response.data && response.data.message && response.data.message.teams) {
        const teamsData = response.data.message.teams || [];
        console.log("EXTRACTED TEAMS DATA:", teamsData);

        const teamsArray = teamsData.map(team => ({
          id: team.id,
          name: team.team
        }));

        console.log("FINAL TEAMS ARRAY:", teamsArray);
        setTeams(teamsArray);
      } else {
        console.error("Unexpected API response structure:", response.data);
        enqueueSnackbar('Unexpected API response format for teams', { variant: 'error' });
        setTeams([]);
      }
    } catch (error) {
      console.error('Error fetching teams:', error);
      if (error.response) {
        console.error('Response data:', error.response.data);
        console.error('Response status:', error.response.status);
      } else if (error.request) {
        console.error('No response received:', error.request);
      } else {
        console.error('Error message:', error.message);
      }

      enqueueSnackbar('Failed to load teams', { variant: 'error' });
      setTeams([]);
    } finally {
      setLoadingTeams(false);
    }
  };

  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    dateOfBirth: "",
    department: "",
    team: "",
    designation: "",
    grade: "",
    phoneNumber: "",
    status: "inActive",
    employmentType: "Full-Time",
    joiningDate: "",
    isManager: false,
    isTeamLead: false,
    location: "",
    reportingManager: '',
    roleId: '',
    roleName: ''
  });

  const [searchQuery, setSearchQuery] = useState("");
  const [filterStatus, setFilterStatus] = useState("All");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [addEmployeeErrorMessage, setAddEmployeeErrorMessage] = useState('');
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [selctedLocationFilter, setSelctedLocationFilter] = useState('All');
  const [anchorEl, setAnchorEl] = useState(null);
  const [downloadFormat, setDownloadFormat] = useState('pdf');
  const [viewEmployeeDetailsOpen, setViewEmployeeDetailsOpen] = useState('');


  const handleEditEmployee = (employee) => {
    setEditEmployeeId(employee.id);
    setIsEditDialogOpen(true);
  };

  const handleEmployeeViewDetails = (employee) => {
    setEditEmployeeId(employee.id);
    setViewEmployeeDetailsOpen(true)
  }

  const handleCloseTokenExpirePopup = () => {
    setOpenTokenExpirePopup(false);
    navigate('/');
  };

  const handleDepartmentChange = (e) => {
    const selectedDeptId = e.target.value;
    console.log("Department selected ID:", selectedDeptId);
    const selectedDept = departments.find(d => d.id === selectedDeptId);

    setFormData({
      ...formData,
      department: selectedDeptId,
      departmentName: selectedDept?.name || '',
      team: "",
      designation: ""
    });

    fetchTeamsByDepartmentId(selectedDeptId);
  };

  const handleTeamChange = (e) => {
    const selectedTeamId = e.target.value;
    console.log("Team selected:", selectedTeamId);
    const selectedTeam = teams.find(t => t.id === selectedTeamId);

    setFormData({
      ...formData,
      team: selectedTeamId,
      teamName: selectedTeam?.name || '',
      designation: ""
    });

    fetchDesignationsByTeamId(selectedTeamId);
  };

  const handleDesignationChange = (e) => {
    const selectedDesignationId = e.target.value;
    console.log("Designation selected:", selectedDesignationId);
    const selectedDesignation = designations.find(d => d.id === selectedDesignationId);

    setFormData({
      ...formData,
      designation: selectedDesignationId,
      designationName: selectedDesignation?.name || ''
    });
  };

  const handleAddEmployee = async () => {
    setShowErrorMessage(false);
    setAddEmployeeErrorMessage("");
    const missingFields = [];

    if (!formData.firstName) missingFields.push("First Name");
    if (!formData.lastName) missingFields.push("Last Name");
    if (!formData.email) missingFields.push("Email");
    if (!formData.department) missingFields.push("Department");
    if (!formData.team) missingFields.push("Team");
    if (!formData.designation) missingFields.push("Designation");
    if (!formData.joiningDate) missingFields.push("Joining Date");
    if (!formData.status) missingFields.push("Status");
    if (!formData.roleId) missingFields.push("Role");
    if (!formData.dateOfBirth) missingFields.push("Role");

    if (missingFields.length > 0) {
      const errorMessage = `The following required fields are missing: ${missingFields.join(", ")}`;
      setAddEmployeeErrorMessage(errorMessage);
      setShowErrorMessage(true);
      return;
    }

    setSnackbarOpen(false);
    setLoading(true);
    const minSpinnerTime = 2000;
    const startTime = Date.now();

    try {


      const employeeData = {
        first_name: formData.firstName,
        last_name: formData.lastName,
        email: formData.email,
        password: "1234",
        organization_id: organizationId,
        department: formData.department,
        team: formData.team,
        designation: formData.designation,
        dob: formData.dateOfBirth,
        doj: formData.joiningDate,
        status: formData.status === "Active" ? "active" : "inactive",
        role_id: formData.roleId,
        location_id: formData.location,
        report_manager_id: formData.reportingManager || null,
        emp_id: formData.employeeId,
      };

      console.log("Sending employee data:", JSON.stringify(employeeData, null, 2));

      const response = await axiosInstance(localAxios("/organization/userSignup", employeeData));

      // ✅ Handle success (201 Created)
      if (response.status === 201) {
        setSnackbarMessage("Employee added successfully!");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);

        const elapsed = Date.now() - startTime;
        const remainingTimeToMinSpinner = minSpinnerTime - elapsed;
        const delayAfterSnackbar = 1500;

        setTimeout(() => {
          setIsDialogOpen(false);
          resetForm();
          setLoading(false);
          fetchAllEmployeesByOrgId(organizationId);
        }, Math.max(delayAfterSnackbar, remainingTimeToMinSpinner));
      }
      // ✅ Handle valid but unexpected status codes (e.g., 200, 202, etc.)
      else if (response.status >= 200 && response.status < 300) {
        setSnackbarMessage(`Employee action completed with status: ${response.status}`);
        setSnackbarSeverity("info");
        setSnackbarOpen(true);

        setTimeout(() => {
          setIsDialogOpen(false);
          resetForm();
          setLoading(false);
        }, 2000);
      }
      // ❌ Handle non-2xx status codes
      else {
        const displayMessage =
          response.data?.message || `Unexpected response: ${response.status}`;
        setAddEmployeeErrorMessage(displayMessage);
        setShowErrorMessage(true);

        setSnackbarMessage(displayMessage);
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error adding employee:", error);

      let displayMessage = "An unexpected error occurred.";
      if (error.response) {
        console.error("Response status:", error.response.status);
        console.error("Response data:", error.response.data);

        if (error.response.status === 409 || error.response.status === 400) {
          displayMessage = error.response.data.message || "Invalid input or employee already exists.";
          setAddEmployeeErrorMessage(displayMessage);
          setShowErrorMessage(true);
        } else if (error.response.data?.message) {
          displayMessage = error.response.data.message;
        } else {
          displayMessage = `Server error: ${error.response.status}`;
        }
      } else if (error.request) {
        displayMessage = "No response from server. Please check your connection.";
      } else {
        displayMessage = `Error: ${error.message}`;
      }

      setSnackbarMessage(displayMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);

      const elapsed = Date.now() - startTime;
      const remainingTimeToMinSpinner = minSpinnerTime - elapsed;
      setTimeout(() => {
        setLoading(false);
      }, remainingTimeToMinSpinner > 0 ? remainingTimeToMinSpinner : 0);
    }
  };



  const filteredEmployees = employees.filter((emp) => {
    const matchesSearch = `${emp.first_name} ${emp.last_name}`
      .toLowerCase()
      .includes(searchQuery.toLowerCase());

    const matchesStatus =
      filterStatus === "All" ||
      (filterStatus === "active" && emp.status && emp.status.toLowerCase() === 'active') ||
      (filterStatus === "inactive" && emp.status && emp.status.toLowerCase() === 'inactive');

    // New filter condition for location based on `id`
    const matchesLocation =
      selctedLocationFilter === "All" ||
      (emp.location === selctedLocationFilter);

    return matchesSearch && matchesStatus && matchesLocation;
  });

  const paginatedEmployees = filteredEmployees.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  const handleDeleteEmployee = async (id) => {
    try {
      console.log('Deleting employee with ID:', id);
      setLoading(true);


      const token = localStorage.getItem('accessToken');


      let response;
      try {

        response = await axiosInstance(localAxiosDelete(`organization/deleteEmploye/${id}`, token));
        if (response.data) {
          fetchAllEmployeesByOrgId(organizationId)
        }
      } catch (innerError) {
        if (innerError.response && innerError.response.status === 404) {
          try {

            response = await axiosInstance(localAxiosDelete(`organization/deleteEmployee/${id}`, token));
          } catch (secondError) {
            if (secondError.response && secondError.response.status === 404) {

              response = await axiosInstance(localAxiosDelete(`organization/deleteUser/${id}`, token));
            } else {
              throw secondError;
            }
          }
        } else {
          throw innerError;
        }
      }

      if (response.data && (response.data.status === "SUCCESS" || response.status === 200)) {
        toast.success('Employee deleted successfully');
        setTimeout(() => {
          fetchAllEmployeesByOrgId(organizationId);
        }, 500);
      } else {
        console.error('Unexpected API response structure:', response.data);
        toast.error('Unexpected response from server');
      }
    } catch (error) {
      console.error('Error deleting employee:', error);

      if (error.response) {
        console.error('Response status:', error.response.status);
        console.error('Response data:', error.response.data);

        if (error.response.data && error.response.data.message) {
          toast.error(error.response.data.message);
        } else {
          toast.error(`Server error: ${error.response.status}`);
        }
      } else if (error.request) {
        console.error('No response received:', error.request);
        toast.error('No response from server. Please check your connection.');
      } else {
        console.error('Error message:', error.message);
        toast.error(`Error: ${error.message}`);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleLocationChange = (e) => {
    const selectedLocationId = e.target.value;
    console.log("Location selected:", selectedLocationId);
    const selectedLocation = locations.find(loc => loc.id === selectedLocationId);

    setFormData({
      ...formData,
      location: selectedLocationId,
      locationName: selectedLocation?.name || ''
    });
  };

  useEffect(() => {
    if (organizationId) {
      console.log("About to fetch departments with organizationId:", organizationId);
      fetchDepartmentsByOrganizationId(organizationId);
      fetchAllEmployeesByOrgId(organizationId);
      fetchLocationsByOrganizationId(organizationId);
      fetchReportingManagersList();
      fetchRolesList();
    } else {
      console.log("No organizationId available yet");
    }
  }, [organizationId]);

  const fetchReportingManagersList = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axiosInstance(localAxiosGet(
        `/project/getAllTeamLeadOrManager?organization_id=${organizationId}&is_manager=true&is_team_lead=true`,
        token
      ));

      if (response.data && response.data.message && response.data.message.users) {
        const managers = [];
        const teamLeads = [];

        response.data.message.users.forEach(user => {
          if (user.user_type === "Manager") {
            managers.push({
              id: user.id,
              name: `${user.first_name} ${user.last_name}(${user.user_type})`,
              userType: user.user_type
            });
          } else if (user.user_type === "Team Lead") {
            teamLeads.push({
              id: user.id,
              name: `${user.first_name} ${user.last_name} (${user.user_type})`,
              userType: user.user_type
            });
          }
        });


        const options = [...managers, ...teamLeads];

        setmanagerOptions(options);
        console.log('Manager options', options);
      }
    } catch (error) {
      console.error('Error fetching reporting managers:', error);

      if (error.response && error.response.status === 404) {
        console.log('API endpoint not found. Using fallback method...');
        const managerEmployees = employees.filter(emp =>
          emp.is_manager || emp.user_type === "Manager" || emp.user_type === "Team Lead"
        );

        const options = managerEmployees.map(user => ({
          id: user.id,
          name: `${user.first_name} ${user.last_name}`,
          userType: user.user_type || "Employee"
        }));

        setmanagerOptions(options);
      }
    }
  };

  const fetchLocationsByOrganizationId = async (orgId) => {
    try {
      setLoadingLocations(true);
      console.log("Fetching locations for organization ID:", orgId);
      const token = localStorage.getItem('accessToken');
      const response = await axiosInstance(localAxiosGet(`/organization/getAllLocationsByOrgId/${orgId}`, token));

      console.log("Locations Response:", response);

      if (response.data && response.data.message) {
        const locationsData = response.data.message || [];
        console.log("Extracted Locations Data:", locationsData);

        const locationsArray = locationsData.map(location => ({
          id: location.id,
          name: location.location_name,
          country: location.country,
          state: location.state,
          city: location.city
        }));

        console.log("Final Locations Array:", locationsArray);
        setLocations(locationsArray);
      } else {
        console.error("Unexpected API response structure:", response.data);
        enqueueSnackbar('Unexpected API response format for locations', { variant: 'error' });
        setLocations([]);
      }
    } catch (error) {
      console.error('Error fetching locations:', error);

      if (error.response) {
        console.error('Response data:', error.response.data);
        console.error('Response status:', error.response.status);
      } else if (error.request) {
        console.error('No response received:', error.request);
      } else {
        console.error('Error message:', error.message);
      }

      enqueueSnackbar('Failed to load locations', { variant: 'error' });
      setLocations([]);
    } finally {
      setLoadingLocations(false);
    }
  };

  const [addEmployeeBulkDialogOpen, setAddEmployeeBulkDialogOpen] = useState(false);

  const handleAddEmployeeInBulk = () => {
    setAddEmployeeBulkDialogOpen(true);
  };

  const fetchRolesList = async () => {
    try {
      const response = await axiosInstance(localAxiosGet(`/organization/getAllRolesByOrgId?organization_id=${organizationId}`, token));
      setRolesNamesList(response.data.result)
    } catch (error) {
      console.error('Error in fetching roles dropdown', error)
    }
  }


  const handleRoleChange = (e) => {
    const selectedRoleId = e.target.value;
    const selectedRoleDetails = rolesNamesList.find(r => r.id === selectedRoleId);
    setFormData({
      ...formData,
      roleId: selectedRoleId,
      roleName: selectedRoleDetails?.name || ''
    })
  }

  const handleOpenPopover = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const popoverOpen = Boolean(anchorEl);

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const handleFormatChange = (event) => {
    setDownloadFormat(event.target.value);
  };

  const handleDownload = async () => {

    try {

      const endpoint = downloadFormat === 'excel' ?
        `/organization/getEmployeeListExcel?organization_id=${organizationId}&status=${filterStatus}&location_id=${selctedLocationFilter}`
        : `/organization/getEmployeeListPDF?organization_id=${organizationId}&status=${filterStatus}&location_id=${selctedLocationFilter}`


      const response = await axiosInstance({
        ...localAxiosGet(endpoint, token),
        responseType: 'blob'
      });

      if (!(response.data instanceof Blob)) {
        throw new Error('Response data is not a Blob');
      }

      // Determine content type and filename as you already have
      const contentType = response.headers['content-type'] ||
        (downloadFormat === 'excel'
          ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          : 'application/pdf');
      const extension = downloadFormat === 'excel' ? 'xlsx' : 'pdf';
      let filename = `Employee List`;
      const contentDisposition = response.headers['content-disposition'];
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
        if (filenameMatch?.[1]) {
          filename = filenameMatch[1];
        }
      }

      // Create and trigger download
      const blob = new Blob([response.data], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();

      // Cleanup
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);


      setSnackbarOpen(true);
      setSnackbarMessage('Download started successfully!');
      setSnackbarSeverity('success')

      setTimeout(() => {
        setAnchorEl(null);
        setDownloadFormat('')
      }, 6000);

    } catch (error) {
      console.error('Download failed:', error);
      setSnackbarOpen(true);
      setSnackbarMessage('Failed to download. Please try again');
      setSnackbarSeverity('error')


    }
  }
  const popoverOpenFordownloadFormat = Boolean(anchorEl);



  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "#f9fafc" }}>
      {loading && <Spinner />}
      <Box
        component="header"
        sx={{
          padding: "16px",
          backgroundColor: "#1565c0",
          color: "#fff",
          boxShadow: 1,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h4" fontWeight="bold">
          Employee Management System
        </Typography>
      </Box>
      <Box >
        {viewEmployeeDetailsOpen ? (

          <ViewEmployeeDetails
            userId={editEmployeeId}
            organizationId={organizationId}
            onClose={() => setViewEmployeeDetailsOpen(false)}
          />) :
          (
            <Box sx={{ padding: "24px", display: "flex", flexDirection: "column", gap: 4 }}>
              <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                <TextField
                  label="Search Employees"
                  variant="outlined"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  sx={{ flexGrow: 1 }}
                />
                <FormControl sx={{ minWidth: 200 }}>
                  <InputLabel>Branch</InputLabel>
                  <Select
                    value={selctedLocationFilter}
                    onChange={(e) => setSelctedLocationFilter(e.target.value)}
                    label='Location'
                  >
                    <MenuItem value="All">All</MenuItem>
                    {locations.map((item) => (
                      <MenuItem key={item.id} value={item.name}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl sx={{ minWidth: 150 }}>
                  <InputLabel>Status</InputLabel>
                  <Select
                    value={filterStatus}
                    onChange={(e) => setFilterStatus(e.target.value)}
                    label="Status"
                  >
                    <MenuItem value="All">All</MenuItem>
                    <MenuItem value="active">Active</MenuItem>
                    <MenuItem value="inactive">inActive</MenuItem>
                  </Select>
                </FormControl>
                <Button variant="outlined" onClick={handleAddEmployeeInBulk}>
                  Add Employees from excel
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    setIsDialogOpen(true);
                    setShowErrorMessage(false);
                    resetForm();
                  }}
                  startIcon={<Person />}
                >
                  Add Employee
                </Button>
                <IconButton onClick={handleOpenPopover}>
                  <FileDownloadOutlinedIcon />
                </IconButton>
                <Popover
                  open={popoverOpen}
                  anchorEl={anchorEl}
                  onClose={handleClosePopover}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
                >
                  <Box sx={{
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    minWidth: 200
                  }}>
                    <FormControl component="fieldset">
                      <RadioGroup
                        aria-label="download-format"
                        name="download-format-group"
                        value={downloadFormat}
                        onChange={handleFormatChange}
                      >
                        <FormControlLabel value="pdf" control={<Radio />} label="PDF" />
                        <FormControlLabel value="excel" control={<Radio />} label="Excel" />
                      </RadioGroup>
                    </FormControl>
                    <Button
                      onClick={handleDownload}
                      variant="contained"
                      startIcon={<CloudDownloadIcon />}
                      size="small"
                    >
                      Download
                    </Button>
                  </Box>
                </Popover>
              </Box>
              <Card sx={{ boxShadow: 3 }}>
                <CardHeader title="Employee List" />
                <CardContent>
                  <TableContainer component={Paper}>
                    <Table>
                      <TableHead>
                        <TableRow sx={{ backgroundColor: "#1565c0" }}>
                          <TableCell sx={{ color: "#fff" }}>Id</TableCell>
                          <TableCell sx={{ color: '#fff', whiteSpace: 'nowrap' }}>Emp Id</TableCell>
                          <TableCell sx={{ color: "#fff" }}>Name</TableCell>
                          <TableCell sx={{ color: "#fff" }}>Department</TableCell>
                          <TableCell sx={{ color: "#fff" }}>Team</TableCell>
                          <TableCell sx={{ color: "#fff" }}>Designation</TableCell>
                          <TableCell sx={{ color: "#fff" }}>Status</TableCell>
                          <TableCell sx={{ color: "#fff" }}>Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {paginatedEmployees.map((employee) => (
                          <TableRow key={employee.id}>
                            <TableCell>{employee.id}</TableCell>
                            <TableCell>{employee.emp_id}</TableCell>
                            <TableCell>
                              {employee.first_name} {employee.last_name}
                            </TableCell>
                            <TableCell>{employee.department}</TableCell>
                            <TableCell>{employee.team}</TableCell>
                            <TableCell>{employee.designation}</TableCell>
                            <TableCell>
                              <Button
                                size="small"
                                variant="contained"
                                color={employee.status && employee.status.toLowerCase() === 'active' ? 'success' : 'warning'}
                                sx={{
                                  textTransform: "capitalize",
                                  '& .muiButton-startIcon': { mr: 0.5 }
                                }}
                                startIcon={employee.status && employee.status.toLowerCase() === 'active' ? <CheckCircle /> : <Cancel />}
                              >
                                {employee.status}
                              </Button>
                            </TableCell>
                            <TableCell>
                              <Box sx={{ display: 'flex', gap: 1 }}>
                                {/* <Tooltip title='Edit Employee'>
                                  <IconButton
                                    onClick={() => handleEditEmployee(employee)}
                                    size="small"
                                    sx={{
                                      color: '#2196f3',
                                      backgroundColor: 'rgba(33, 150, 243, 0.08)',
                                      '&:hover': {
                                        backgroundColor: 'rgba(33, 150, 243, 0.15)'
                                      },
                                      transition: 'all 0.2s ease'
                                    }}
                                  >
                                    <EditIcon />
                                  </IconButton>
                                </Tooltip> */}
                                <Tooltip title='View Employee Details'>
                                  <IconButton
                                    onClick={() => handleEmployeeViewDetails(employee)}
                                    size="small"
                                    sx={{
                                      color: '#1976d2',
                                      backgroundColor: 'rgba(25, 118, 210, 0.08)',
                                      '&:hover': {
                                        backgroundColor:
                                          'rgba(25, 118, 210, 0.08)'

                                      },
                                      transition: 'all 0.2s ease',
                                    }}
                                  >
                                    <VisibilityIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </Box>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Showing {Math.min((page - 1) * rowsPerPage + 1, filteredEmployees.length)}-
                      {Math.min(page * rowsPerPage, filteredEmployees.length)} of {filteredEmployees.length} employees
                    </Typography>

                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography variant="body2" sx={{ mr: 1 }}>Rows per page:</Typography>
                        <Select
                          value={rowsPerPage}
                          onChange={(e) => {
                            setRowsPerPage(e.target.value);
                            setPage(1); // Reset to first page when changing rows per page
                          }}
                          size="small"
                          sx={{ height: '36px' }}
                        >
                          <MenuItem value={5}>5</MenuItem>
                          <MenuItem value={10}>10</MenuItem>
                          <MenuItem value={25}>25</MenuItem>
                          <MenuItem value={50}>50</MenuItem>
                        </Select>
                      </Box>
                      <Pagination
                        count={Math.ceil(filteredEmployees.length / rowsPerPage)}
                        page={page}
                        onChange={(e, value) => setPage(value)}
                      />
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Box>
          )}
        <Dialog
          open={isDialogOpen}
          onClose={() => setIsDialogOpen(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle sx={{ backgroundColor: "#1565c0", color: "#fff" }}>
            Add New Employee
          </DialogTitle>
          <DialogContent sx={{ padding: "24px" }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 3, mt: 2 }}>
              <Typography variant="h6" color="primary">
                Personal Information
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    label="First Name"
                    fullWidth
                    required
                    value={formData.firstName}
                    onChange={(e) =>
                      setFormData({ ...formData, firstName: e.target.value })
                    }
                    InputProps={{
                      startAdornment: <Person sx={{ mr: 1, color: "#1565c0" }} />,
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    label="Last Name"
                    fullWidth
                    required
                    value={formData.lastName}
                    onChange={(e) =>
                      setFormData({ ...formData, lastName: e.target.value })
                    }
                    InputProps={{
                      startAdornment: <Person sx={{ mr: 1, color: "#1565c0" }} />,
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    label="Email"
                    type="email"
                    fullWidth
                    required
                    value={formData.email}
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                    InputProps={{
                      startAdornment: <Email sx={{ mr: 1, color: "#1565c0" }} />,
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    label="Phone Number"
                    type="tel"
                    fullWidth
                    inputProps={{ maxLength: 10 }}
                    value={formData.phoneNumber}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, ''); // Allow only digits
                      setFormData({ ...formData, phoneNumber: value });
                    }}
                    InputProps={{
                      startAdornment: <Phone sx={{ mr: 1, color: "#1565c0" }} />,
                    }}
                  />

                </Grid>
                <Grid item xs={6}>
                  <TextField
                    label="Date of Birth"
                    type="date"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    value={formData.dateOfBirth}
                    onChange={(e) =>
                      setFormData({ ...formData, dateOfBirth: e.target.value })
                    }
                    InputProps={{
                      startAdornment: <Cake sx={{ mr: 1, color: "#1565c0" }} />,
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    label="Joining Date"
                    type="date"
                    fullWidth
                    required
                    InputLabelProps={{ shrink: true }}
                    value={formData.joiningDate}
                    onChange={(e) =>
                      setFormData({ ...formData, joiningDate: e.target.value })
                    }
                  />
                </Grid>
              </Grid>
              <Typography variant="h6" color="primary">
                Professional Information
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <Autocomplete
                      options={departments}
                      getOptionLabel={(option) => option.name}
                      value={departments.find(dept => dept.id === formData.department) || null}
                      onChange={(event, newValue) => {
                        setFormData({
                          ...formData,
                          department: newValue ? newValue.id : "",
                          departmentName: newValue ? newValue.name : "",
                          team: "",
                          designation: ""
                        });
                        if (newValue) {
                          fetchTeamsByDepartmentId(newValue.id);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Department"
                          required
                          InputProps={{
                            ...params.InputProps,
                          }}
                        />
                      )}
                      disabled={loading}
                    />


                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <Autocomplete
                      options={teams}
                      getOptionLabel={(option) => option.name}
                      value={teams.find(team => team.id === formData.team) || null}
                      onChange={(event, newValue) => {
                        setFormData({
                          ...formData,
                          team: newValue ? newValue.id : "",
                          teamName: newValue ? newValue.name : "",
                          designation: ""
                        });
                        if (newValue) {
                          fetchDesignationsByTeamId(newValue.id);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Team"
                          required
                          InputProps={{
                            ...params.InputProps,

                          }}
                        />
                      )}
                      disabled={!formData.department || loadingTeams}
                    />

                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <Autocomplete
                      options={designations}
                      getOptionLabel={(option) => option.name}
                      value={designations.find(designation => designation.id === formData.designation) || null}
                      onChange={(event, newValue) => {
                        setFormData({
                          ...formData,
                          designation: newValue ? newValue.id : "",
                          designationName: newValue ? newValue.name : ""
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Designation"
                          required
                          InputProps={{
                            ...params.InputProps,

                          }}
                        />
                      )}
                      disabled={!formData.team || loadingDesignations}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <Autocomplete
                      options={rolesNamesList}
                      getOptionLabel={(option) => option.name}
                      value={rolesNamesList.find(role => role.id === formData.roleId) || null}
                      onChange={(event, newValue) => {
                        setFormData({
                          ...formData,
                          roleId: newValue ? newValue.id : '',
                          roleName: newValue ? newValue.name : ''
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Role"
                          required
                        />
                      )}
                    />
                  </FormControl>

                </Grid>
                {/* <Grid item xs={6}>
                  <Paper
                    elevation={1}
                    sx={{
                      p: 1.5,
                      display: 'flex',
                      alignItems: 'center',
                      borderLeft: formData.isManager ? '4px solid #1565c0' : '4px solid transparent',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        boxShadow: 2,
                        backgroundColor: '#f5f9ff'
                      },
                      opacity: formData.isTeamLead ? 0.6 : 1,
                      cursor: formData.isTeamLead ? 'not-allowed' : 'pointer'
                    }}
                    onClick={() => {
                      if (!formData.isTeamLead) {
                        setFormData({ ...formData, isManager: !formData.isManager });
                      }
                    }}
                  >
                    <Checkbox
                      checked={formData.isManager}
                      onChange={(e) => {
                        if (!formData.isTeamLead) {
                          setFormData({ ...formData, isManager: e.target.checked });
                        }
                      }}
                      color="primary"
                      sx={{ mr: 1 }}
                      disabled={formData.isTeamLead}
                    />
                    <Box>
                      <Typography variant="body1" fontWeight={500}>Is Manager</Typography>
                      <Typography variant="caption" color="text.secondary">
                        Can manage team members and approve requests
                      </Typography>
                    </Box>
                  </Paper>
                </Grid>
                <Grid item xs={6}>
                  <Paper
                    elevation={1}
                    sx={{
                      p: 1.5,
                      display: 'flex',
                      alignItems: 'center',
                      borderLeft: formData.isTeamLead ? '4px solid #1565c0' : '4px solid transparent',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        boxShadow: 2,
                        backgroundColor: '#f5f9ff'
                      },
                      opacity: formData.isManager ? 0.6 : 1,
                      cursor: formData.isManager ? 'not-allowed' : 'pointer'
                    }}
                    onClick={() => {
                      if (!formData.isManager) {
                        setFormData({ ...formData, isTeamLead: !formData.isTeamLead });
                      }
                    }}
                  >
                    <Checkbox
                      checked={formData.isTeamLead}
                      onChange={(e) => {
                        if (!formData.isManager) {
                          setFormData({ ...formData, isTeamLead: e.target.checked });
                        }
                      }}
                      color="primary"
                      sx={{ mr: 1 }}
                      disabled={formData.isManager}
                    />
                    <Box>
                      <Typography variant="body1" fontWeight={500}>Is Team Lead</Typography>
                      <Typography variant="caption" color="text.secondary">
                        Can lead team activities and projects
                      </Typography>
                    </Box>
                  </Paper>
                </Grid> */}

                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <Autocomplete
                      options={managerOptions}
                      getOptionLabel={(option) => option.name}
                      value={managerOptions.find(manager => manager.id === formData.reportingManager) || null}
                      onChange={(event, newValue) => {
                        setFormData({
                          ...formData,
                          reportingManager: newValue ? newValue.id : ''
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Reporting Supervisor"
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <InputLabel>Status</InputLabel>
                    <Select
                      value={formData.status}
                      onChange={(e) =>
                        setFormData({ ...formData, status: e.target.value })
                      }
                      label="Status"
                      defaultValue="inActive"
                      required
                    >
                      <MenuItem value="inActive">inActive</MenuItem>
                      <MenuItem value="Active">Active</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    label="Employee ID"
                    fullWidth
                    value={formData.employeeId}
                    onChange={(e) =>
                      setFormData({ ...formData, employeeId: e.target.value })
                    }

                  />
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <Autocomplete
                      options={locations}
                      getOptionLabel={(option) => `${option.name} (${option.city}, ${option.state})`}
                      value={locations.find(location => location.id === formData.location) || null}
                      onChange={(event, newValue) => {
                        setFormData({
                          ...formData,
                          location: newValue ? newValue.id : "",
                          locationName: newValue ? newValue.name : ''
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Location"
                          InputProps={{
                            ...params.InputProps,

                          }}
                        />
                      )}
                      disabled={loadingLocations}
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
          </DialogContent>
          <DialogActions sx={{ padding: "16px" }}>
            {showErrorMessage && (
              <Box sx={{
                p: 1,
                bgcolor: '#ffebee',
                borderRadius: 1,
                display: 'flex',
                alignItems: 'center',
                color: '#d32f2f'
              }}>
                <Cancel sx={{ mr: 1 }} />
                <Typography variant="body2">{addEmployeeErrorMessage}</Typography>
              </Box>
            )}
            <Button
              onClick={handleCancelButton}
              variant="outlined"
              color="error"
              startIcon={<Cancel />}
            >
              Cancel
            </Button>
            <Button
              onClick={handleAddEmployee}
              variant="contained"
              color="primary"
              startIcon={<CheckCircle />}
              disabled={loading}
            >
              Add Employee
            </Button>
          </DialogActions>
        </Dialog>


        <EditEmployeeDetails
          open={isEditDialogOpen}
          onClose={() => setIsEditDialogOpen(false)}
          userId={editEmployeeId}
          organizationId={organizationId}
          onEmployeeUpdated={() => fetchAllEmployeesByOrgId(organizationId)}
          token={token}
        />


        <AddEmployeeUsingCSV
          open={addEmployeeBulkDialogOpen}
          onClose={() => setAddEmployeeBulkDialogOpen(false)}
          onEmployeesAdded={() => fetchAllEmployeesByOrgId(organizationId)}
          organizationId={organizationId}
        />



        {/*        
        <TokenExpirePopup
          open={openTokenExpirePopup}
          onClose={handleCloseTokenExpirePopup}
        /> */}


        {/* <Modal
          open={addEmployeeBulkDialogOpen}
          onClose={() => setAddEmployeeBulkDialogOpen(false)}
        >
          <AddEmployeeUsingCSV onClose={() => setAddEmployeeBulkDialogOpen(false)} />
        </Modal > */}


        < Modal
          open={openTokenExpirePopup}
          onClose={handleCloseTokenExpirePopup}
        >
          <TokenExpirePopup onClose={handleCloseTokenExpirePopup} />
        </Modal >


        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity={snackbarSeverity}
            sx={{ width: '100%' }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Box >
    </Box>

  );
}